import { render, staticRenderFns } from "./Summary_view.vue?vue&type=template&id=768b94ec&scoped=true&"
import script from "./Summary_view.vue?vue&type=script&lang=js&"
export * from "./Summary_view.vue?vue&type=script&lang=js&"
import style0 from "./Summary_view.vue?vue&type=style&index=0&id=768b94ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768b94ec",
  null
  
)

export default component.exports